export const postRefreshData = async (routeId, duration) => {
  const postData = new FormData();
  postData.append("func", "postRoutes");
  postData.append("route", routeId);
  postData.append("token", "sfasfads1123@$V@$");
  postData.append("duration", duration);

  const refreshData = await fetch(
    "https://nafpaktos.smartiscity.gr/api/api.php?func=postRoutes",
    {
      method: "POST",
      body: postData,
    }
  )
    .then((response) => response?.json())
    .catch((error) => {
      console.error("TEST: post error", error);
      return {};
    });

  return refreshData;
};

export const getRefreshData = async (routeId) => {
  const postData = new FormData();
  postData.append("func", "getRoutes");
  postData.append("route", routeId);
  postData.append("token", "sfasfads1123@$V@$");

  const refreshData = await fetch(
    "https://nafpaktos.smartiscity.gr/api/api.php?func=getRoutes",
    {
      method: "POST",
      body: postData,
    }
  )
    .then((response) => response?.json())
    .catch((error) => {
      console.error("TEST: get error", error);
      return {};
    });

  return refreshData;
};
